import $ from './el.JsModules.js';

elabs.SideCart = class {
  'use strict';
  constructor() {
    $('.el-header__secondary-nav-link--cart').click((evt) => {
      this.openDrawer();
      evt.stopPropagation();
      evt.preventDefault();
    });

    setTimeout(() => {
      // this.openDrawer();
    }, 1);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('show-cart') === 'true') {
      const url = new URL(window.location);
      url.searchParams.delete('show-cart');
      window.history.replaceState({}, '', url);
      this.openDrawer();
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      setTimeout(() => {
        elabs.Bootstrap.initialiseTooltips('.cart-drawer [data-tippy-content]');
      }, 1800);
    });
  }

  openDrawer = () => {
    const cartDrawerElement = document.querySelector('cart-drawer');
    if (cartDrawerElement) {
      cartDrawerElement.open();
    }

    //document.querySelector('button[aria-controls="CartDrawer"]')?.click();

    /*if (drawer) {
      drawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    }*/
  };

  closeDrawer = () => {
    const cartDrawerElement = document.querySelector('cart-drawer');
    if (cartDrawerElement) {
      cartDrawerElement.close();
    }
  };

  updateCartAttribute = (attributeName, value) => {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeName]: value,
        },
      }),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(`EL Error updating cart attribute: ${attributeName}`, error);
        }
        return response.json();
      })
      .then((cart) => {})
      .catch((error) => {
        console.error(`EL Error updating cart attribute: ${attributeName}`, error);
      });
  };
};

elabs.onJavascriptReady(() => {
  elabs.SideCart = new elabs.SideCart();
});
